/**
 * Utilitários para operações com localStorage
 */

/**
 * Salva um valor no localStorage
 * @param {string} key - Chave para armazenamento
 * @param {any} value - Valor a ser armazenado
 */
export const saveToStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.warn("Erro ao salvar no localStorage:", error);
  }
};

/**
 * Recupera um valor do localStorage
 * @param {string} key - Chave para recuperação
 * @param {any} defaultValue - Valor padrão se não encontrado
 * @returns {any} Valor recuperado ou valor padrão
 */
export const getFromStorage = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.warn("Erro ao recuperar do localStorage:", error);
    return defaultValue;
  }
};

/**
 * Remove uma chave do localStorage
 * @param {string} key - Chave a ser removida
 */
export const removeFromStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.warn("Erro ao remover do localStorage:", error);
  }
};

/**
 * Remove múltiplas chaves do localStorage
 * @param {string[]} keys - Array de chaves a serem removidas
 */
export const removeMultipleFromStorage = (keys) => {
  keys.forEach(key => removeFromStorage(key));
};